module.exports = angular.module(__filename, []).directive("appNameLabel", ["$state", function ($state) {
    return {
        restrict: "E",
        template: require("./app-name-label.html"),  
    }
}]);
